function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M50 10.183c-21.956 0-39.817 17.862-39.817 39.817 0 21.955 17.862 39.817 39.817 39.817 21.955 0 39.817-17.862 39.817-39.817 0-21.956-17.862-39.817-39.817-39.817zm0 75.634C30.25 85.817 14.183 69.75 14.183 50S30.25 14.183 50 14.183 85.817 30.25 85.817 50 69.75 85.817 50 85.817z",
  fill: "#717375"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M67.037 48H52V18.863a2 2 0 0 0-4 0v31c0 1.104.933 2.137 2.037 2.137h17a2 2 0 0 0 0-4z",
  fill: "#717375"
});

function SvgFullTime(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 100 100"
  }, props), _ref, _ref2);
}

export default SvgFullTime;